<template>
  <bpb-form-communicator v-model="internalValue" :name="name">
    <div
      :id="id"
      class="input-checkbox-list"
      v-bind="$fieldUpdateBinding"
      tabindex="-1"
    >
      <slot />
      <bpb-form-error-portal :name="name" />
    </div>
  </bpb-form-communicator>
</template>

<script>
import {
  InputIdProvider,
  FieldUpdateProvider,
} from '@components/molecules/form/form.mixin.js';

export default {
  mixins: [
    InputIdProvider,
    FieldUpdateProvider({ baseClass: 'input-checkbox-list' }),
  ],

  provide() {
    const context = {};
    Object.defineProperty(context, 'name', {
      enumerable: true,
      get: () => this.name,
    });
    Object.defineProperty(context, 'id', {
      enumerable: true,
      get: () => this.id,
    });
    Object.defineProperty(context, 'internalValue', {
      enumerable: true,
      get: () => this.internalValue,
    });
    return {
      context,
      onOptionChange: this.onOptionChange,
    };
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      internalValue: this.value,
      uuid: this.$uuid.v1(),
    };
  },
  methods: {
    onOptionChange(value, checked) {
      checked ? this.add(value) : this.remove(value);
    },
    add(value) {
      let componentValue = [...this.internalValue];

      if (componentValue.includes(value)) return false;
      componentValue.push(value);

      this.set(componentValue);
    },
    remove(value) {
      let componentValue = [...this.internalValue];

      if (componentValue.includes(value)) {
        componentValue.splice(componentValue.indexOf(value), 1);
      }

      this.set(componentValue);
    },
    set(value) {
      this.internalValue = value;
      this.$emit('change', value);
    },
  },
};
</script>
